import React from 'react';

export const checkContextMenu = (contextMenu, id, depth, resourceCount) => {

    //SF[00198390]
    const user= JSON.parse(localStorage.getItem('user'));
    const authority = user.authority;
    const isServerAdmin = user.serverAdmin;
    const isMultiOrganizationManager= user.isMultiOrganizationManager;
    const isRootOrgUser = user.groupId === 0;
    const hasContentCreateAuth = authority && authority.CONTENT_PLAYLIST_RULESET && authority.CONTENT_PLAYLIST_RULESET.CREATE;

    switch (id) {
        case 'BY_USER':
            contextMenu[0].disabled = true;
            contextMenu[1].disabled = true;
            contextMenu[2].disabled = true;
            break;
        case 'SHARED_CONTENT':
            //SF[00198390]
            if(isServerAdmin || (isMultiOrganizationManager && hasContentCreateAuth) || (isRootOrgUser && hasContentCreateAuth)){
                if (parseInt(depth) < 0) {
                    contextMenu[1].disabled = true;
                    contextMenu[2].disabled = true;
                    contextMenu[3].disabled = true;
                } else {
                    contextMenu[1].disabled = false;
                    contextMenu[2].disabled = false;
                    contextMenu[3].disabled = false;
                }
            } else {
                contextMenu[0].disabled = true;
                contextMenu[1].disabled = true;
                contextMenu[2].disabled = true;
                contextMenu[3].disabled = true;
            }
            break;
        case 'MY_CONTENT':
            if(!(authority.CONTENT_PLAYLIST_RULESET.CREATE || authority.CONTENT_PLAYLIST_RULESET.MANAGE)){
                contextMenu[0].disabled = true;
                contextMenu[1].disabled = true;
                contextMenu[2].disabled = true;
            }else {
                if (parseInt(depth) < 1) {
                    contextMenu[1].disabled = true;
                    contextMenu[2].disabled = true;
                } else {
                    contextMenu[1].disabled = false;
                    contextMenu[2].disabled = false;
                }
            }
            break;
        case 'MY_PLAYLIST':
            if (parseInt(depth) < 1) { // default
                contextMenu[0].disabled = false;
                contextMenu[1].disabled = true;
                contextMenu[2].disabled = true;
            } else {
                contextMenu[0].disabled = false;
                contextMenu[1].disabled = false;
                contextMenu[2].disabled = false;
            }
            break;
        case 'PLAYLIST_BY_USER':
            contextMenu[0].disabled = true;
            contextMenu[1].disabled = true;
            contextMenu[2].disabled = true;
            break;
        case 'RULESET_BY_GROUP' : 
        case 'CONTENT_SCHEDULE_BY_GROUP':
        case 'MESSAGE_SCHEDULE_BY_GROUP':
        case 'EVENT_SCHEDULE_BY_GROUP':
            if (parseInt(depth) < 2) {
                contextMenu[0].disabled = false;
                contextMenu[1].disabled = true;
                contextMenu[2].disabled = true;
            } else {
                contextMenu[0].disabled = false;
                contextMenu[1].disabled = false;
                contextMenu[2].disabled = resourceCount !== undefined && resourceCount > 0 ? true : false;
            }

            break;
        case 'USER_BY_GROUP':
            contextMenu[0].disabled = false;
            contextMenu[1].disabled = false;
            contextMenu[2].disabled = false;
            break;
        case 'DEVICE_BY_GROUP':
            if (parseInt(depth) < 2) {
                contextMenu[0].disabled = false;
                contextMenu[1].disabled = true;
                contextMenu[2].disabled = true;
            } else {
                contextMenu[0].disabled = false;
                contextMenu[1].disabled = false;
                contextMenu[2].disabled = resourceCount > 0 ? true : false;
            }
            break;
        default: {
            if (parseInt(depth) < 2) {
                contextMenu[1].disabled = true;
                contextMenu[2].disabled = true;
            } else {
                contextMenu[1].disabled = false;
                contextMenu[2].disabled = false;
            }
        }
    }
    return contextMenu;
}

